import { useTranslation } from "react-i18next";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";

import BaseButton from "@/components_v2/Button/BaseButton";
import DataFilesTable from "@/views/files/components/DataFilesTable";
import CreateDataFileModal from "@/views/files/components/CreateDataFileModal";
import { useGetCurrentUserQuery } from "@/redux/service";

import "./styles.css";

const DataBlockFiles = () => {
  const { t } = useTranslation();

  const { data: currentUser } = useGetCurrentUserQuery();
  const [openUploadModal, setOpenUploadModal] = useState(false);

  return (
    <div className="data-block-files">
      <div className="data-block-files-header">
        <h1 className="header-l-medium">
          {t("datablocks.labels.fileRepository")}
        </h1>
        <BaseButton
          size="small"
          leadingIcon={<PlusOutlined />}
          onClick={() => {
            setOpenUploadModal(true);
          }}
        >
          {t("datablocks.labels.uploadFiles")}
        </BaseButton>
      </div>

      {currentUser && (
        <DataFilesTable
          columnNames={[
            "name",
            "extension",
            "references",
            "uploadedAt",
            "uploadedBy",
            "actions",
          ]}
          filterNames={["search", "extensions", "uploadedAt", "uploadedBy"]}
          defaultFilters={{
            editable: true,
            organization: currentUser.organization?.id,
          }}
        />
      )}

      <CreateDataFileModal
        open={openUploadModal}
        setOpen={setOpenUploadModal}
      />
    </div>
  );
};

export default DataBlockFiles;
